import React, { FC } from 'react'
import Header from 'src/components/Header'
import Footer from 'src/components/Footer'
import useGetProfile from 'src/hooks/useGetProfile'
import { CategoriesApi, CategoriesWithArea } from 'src/service/api/api.types'
import { useIsIOSPlatform } from 'src/context/PlatformContext'

interface Props {
  showCategory?: boolean
  categories?: CategoriesApi
  children: React.ReactNode
  customCategories?: Record<string, CategoriesWithArea>
  isIOSPlatform?: boolean
}

const PublicLayout: FC<Props> = ({
  children,
  showCategory,
  categories,
  customCategories,
  isIOSPlatform,
}) => {
  useGetProfile()
  const platformIsIOS = isIOSPlatform ?? useIsIOSPlatform()

  return (
    <>
      <Header
        categories={categories}
        customCategories={customCategories}
        showCategory={showCategory}
        isIOSPlatform={platformIsIOS}
      />
      <main>{children}</main>
      <Footer />
    </>
  )
}

export default PublicLayout
